export const projectDefaultWidgets = () => {
  const widgets: any = {
    laMeuse: {
      widgets: [
        {
          type: 'QUALITY_OF_LIFE',
          label: 'Qualité de vie'
        },
        {
          type: 'ENVIRONMENT',
          label: 'Environnement'
        },
        {
          type: 'INFRASTRUCTURE',
          label: 'Infrastructure'
        },
        {
          type: 'ECONOMIC_ECOSYSTEM',
          label: 'Écosystème économique'
        },
        {
          type: 'IMMOVABLE',
          label: 'Immobilier'
        }
      ],
      qualityOfLife: [
        {
          icon: 'nature',
          selected: false,
          label: 'Nature et découverte',
          type: 'points-of-interest'
        },
        {
          icon: 'coffeeHotelRestaurant',
          selected: false,
          label: 'Hébergement / Restauration',
          type: 'CAFE_HOTEL_RESTAURANT',
          open: false,
          subCat: [
            {
              icon: 'hotel',
              selected: false,
              label: 'Hôtels',
              type: 'hotels'
            },
            {
              icon: 'coffeeHotelRestaurant',
              selected: false,
              label: 'Cafés / Restaurants',
              type: 'restaurants'
            },
            {
              icon: 'gites',
              selected: false,
              label: 'Gîtes',
              type: 'gites'
            },
            {
              icon: 'bed',
              selected: false,
              label: "Chambres d'hôtes",
              type: 'guest-rooms'
            }
          ]
        },
        {
          icon: 'commerces',
          selected: false,
          label: 'Commerces',
          type: 'SHOPS',
          open: false,
          subCat: [
            {
              icon: 'producteurs',
              selected: false,
              label: 'Commerces, producteurs locaux',
              type: 'shops'
            },
            {
              icon: 'supermarkets',
              selected: false,
              label: 'Supermarchés',
              type: 'supermarkets'
            }
          ]
        },
        {
          icon: 'entertainment-places',
          selected: false,
          label: 'Sports & Loisirs',
          type: 'SPORTS&LEISURE',
          open: false,
          subCat: [
            {
              icon: 'entertainment-places',
              selected: false,
              label: 'Lieux de sortie',
              type: 'entertainment-places'
            },
            {
              icon: 'activities',
              selected: false,
              label: 'Activités',
              type: 'activities'
            }
          ]
        },
        {
          icon: 'health',
          selected: false,
          label: 'Santé',
          type: 'HEALTH',
          open: false,
          subCat: [
            {
              icon: 'generalist',
              selected: false,
              label: 'Médecins généralistes',
              type: 'generalist'
            },
            {
              icon: 'specialist',
              selected: false,
              label: 'Médecins spécialistes',
              type: 'specialist'
            },
            {
              icon: 'dentist',
              selected: false,
              label: 'Dentistes',
              type: 'dentist'
            },
            {
              icon: 'hospitals',
              selected: false,
              label: 'Cliniques & hôpitaux',
              type: 'hospitals'
            },
            {
              icon: 'health',
              selected: false,
              label: 'Pharmacies',
              type: 'pharmacies'
            }
          ]
        },
        {
          icon: 'education',
          selected: false,
          label: 'Éducation',
          type: 'EDUCATION',
          open: false,
          subCat: [
            {
              icon: 'nurseries',
              selected: false,
              label: 'Crèches',
              type: 'nurseries'
            },
            {
              icon: 'school',
              selected: false,
              label: 'Primaires',
              type: 'primaire'
            },
            {
              icon: 'education',
              selected: false,
              label: 'Collèges',
              type: 'college'
            },
            {
              icon: 'education',
              selected: false,
              label: 'Lycées',
              type: 'lycee'
            }
          ]
        }
      ],
      environnement: [
        {
          icon: 'greenSpace',
          selected: false,
          label: 'Espaces verts',
          type: 'green-spaces-environment'
        },
        {
          icon: 'air',
          selected: false,
          label: 'Qualité de l’air',
          type: 'air-quality'
        },
        {
          icon: 'noise-level',
          selected: false,
          label: 'Niveau de bruit',
          type: 'noise-level'
        }
      ],
      infrastructure: [
        {
          icon: 'cellularNetwork',
          selected: false,
          label: 'Internet 4G & 5G',
          type: 'INTERNET4G&5G',
          open: false,
          subCat: [
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'Free Mobile',
              type: 'free-mobile',
              radio: true
            },
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'Bouygues',
              type: 'bouygues',
              radio: true
            },
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'SFR',
              type: 'sfr',
              radio: true
            },
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'Orange',
              type: 'orange',
              radio: true
            }
          ]
        },
        {
          icon: 'wire',
          selected: false,
          label: 'Internet fibre',
          type: 'internet-fibre'
        },
        {
          icon: 'ev',
          selected: false,
          label: 'Bornes de recharge véh. éléctriques',
          type: 'charging-stations'
        }
      ],
      economicEcosystem: [
        {
          icon: 'jobSearch',
          selected: false,
          label: 'Bassin de recrutement',
          type: 'RECRUITMENT_POOL'
        },
        {
          icon: 'work',
          selected: false,
          label: 'Emplois',
          type: 'JOBS'
        },
        {
          icon: 'activityZone',
          selected: false,
          label: 'Entreprises',
          type: 'COMPANIES-ADMINISTRATIONS',
          open: false,
          subCat: [
            {
              icon: 'activityZone',
              selected: false,
              label: 'Grandes entreprises',
              type: 'big-enterprises'
            },
            {
              icon: 'activityZone',
              selected: false,
              label: 'PME',
              type: 'small-medium-enterprises'
            }
          ]
        }
      ],
      immovable: [
        {
          icon: 'coworking',
          selected: false,
          label: 'Coworking',
          type: 'coworkings'
        },
        {
          icon: 'jobSearch',
          selected: false,
          label: 'Agences immobilières',
          type: 'real-estate-agencies'
        },
        {
          icon: 'activityZone',
          selected: false,
          label: "Offre foncière d'entreprise",
          type: 'lands'
        }
      ]
    },
    valleeSud: {
      widgets: [
        {
          type: 'QUALITY_OF_LIFE',
          label: 'Qualité de vie'
        },
        {
          type: 'ENVIRONMENT',
          label: 'Environnement'
        },
        {
          type: 'INFRASTRUCTURE',
          label: 'Infrastructure'
        },
        {
          type: 'ECONOMIC_ECOSYSTEM',
          label: 'Écosystème économique'
        },
        {
          type: 'IMMOVABLE',
          label: 'Immobilier'
        }
      ],
      qualityOfLife: [
        {
          icon: 'nature',
          selected: false,
          label: 'Espaces verts',
          type: 'points-of-interest'
        },
        {
          icon: 'coffeeHotelRestaurant',
          selected: false,
          label: 'Hébergement / Restauration',
          type: 'CAFE_HOTEL_RESTAURANT',
          open: false,
          subCat: [
            {
              icon: 'hotel',
              selected: false,
              label: 'Hôtels',
              type: 'hotels'
            },
            {
              icon: 'coffeeHotelRestaurant',
              selected: false,
              label: 'Cafés / Restaurants',
              type: 'restaurants'
            }
          ]
        },
        {
          icon: 'commerces',
          selected: false,
          label: 'Commerces',
          type: 'SHOPS',
          open: false,
          subCat: [
            // {
            //   icon: 'producteurs',
            //   selected: false,
            //   label: 'Commerces, producteurs locaux',
            //   type: 'shops'
            // },
            {
              icon: 'supermarkets',
              selected: false,
              label: 'Supermarchés',
              type: 'supermarkets'
            },
            {
              icon: 'supermarkets',
              selected: false,
              label: 'Alimentation de proximité',
              type: 'localFood'
            },
            {
              icon: 'supermarkets',
              selected: false,
              label: 'Maison',
              type: 'house'
            },
            {
              icon: 'supermarkets',
              selected: false,
              label: 'Bien-être',
              type: 'welfare'
            },
            {
              icon: 'supermarkets',
              selected: false,
              label: 'Santé (!! supprimer les pharmacies !!)',
              type: 'health'
            }
          ]
        },
        {
          icon: 'entertainment-places',
          selected: false,
          label: 'Sports & Loisirs',
          type: 'SPORTS&LEISURE',
          open: false,
          subCat: [
            {
              icon: 'entertainment-places',
              selected: false,
              label: 'Culture (Cinéma / Théâtre)',
              type: 'entertainment-places'
            },
            {
              icon: 'activities',
              selected: false,
              label: 'Equipements sportifs',
              type: 'activities'
            }
          ]
        },
        {
          icon: 'health',
          selected: false,
          label: 'Santé',
          type: 'HEALTH',
          open: false,
          subCat: [
            {
              icon: 'generalist',
              selected: false,
              label: 'Médecins généralistes',
              type: 'generalist'
            },
            {
              icon: 'specialist',
              selected: false,
              label: 'Médecins spécialistes',
              type: 'specialist'
            },
            {
              icon: 'dentist',
              selected: false,
              label: 'Dentistes',
              type: 'dentist'
            },
            {
              icon: 'hospitals',
              selected: false,
              label: 'Cliniques & hôpitaux',
              type: 'hospitals'
            },
            {
              icon: 'health',
              selected: false,
              label: 'Pharmacies',
              type: 'pharmacies'
            }
          ]
        },
        {
          icon: 'education',
          selected: false,
          label: 'Éducation',
          type: 'EDUCATION',
          open: false,
          subCat: [
            {
              icon: 'nurseries',
              selected: false,
              label: 'Crèches',
              type: 'nurseries'
            },
            {
              icon: 'school',
              selected: false,
              label: 'Primaires',
              type: 'primaire'
            },
            {
              icon: 'education',
              selected: false,
              label: 'Collèges',
              type: 'college'
            },
            {
              icon: 'education',
              selected: false,
              label: 'Lycées',
              type: 'lycee'
            }
          ]
        }
      ],
      environnement: [
        {
          icon: 'greenSpace',
          selected: false,
          label: 'Cumul des nuisances',
          type: 'cumulativeNuisance'
        },
        {
          icon: 'greenSpace',
          selected: false,
          label: 'Ilots de chaleur',
          type: 'heatIslands'
        },
        {
          icon: 'air',
          selected: false,
          label: 'Qualité de l’air',
          type: 'air-quality'
        },
        {
          icon: 'noise-level',
          selected: false,
          label: 'Niveau de bruit',
          type: 'noise-level'
        }
      ],
      infrastructure: [
        {
          icon: 'cellularNetwork',
          selected: false,
          label: 'Internet 4G & 5G',
          type: 'INTERNET4G&5G',
          open: false,
          subCat: [
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'Free Mobile',
              type: 'free-mobile',
              radio: true
            },
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'Bouygues',
              type: 'bouygues',
              radio: true
            },
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'SFR',
              type: 'sfr',
              radio: true
            },
            {
              icon: 'cellularNetwork',
              selected: false,
              label: 'Orange',
              type: 'orange',
              radio: true
            }
          ]
        },
        {
          icon: 'wire',
          selected: false,
          label: 'Internet fibre',
          type: 'internet-fibre'
        },
        {
          icon: 'ev',
          selected: false,
          label: 'Bornes de recharge véh. éléctriques',
          type: 'charging-stations'
        }
      ],
      economicEcosystem: [
        {
          icon: 'jobSearch',
          selected: false,
          label: 'Bassin de recrutement',
          type: 'RECRUITMENT_POOL'
        },
        {
          icon: 'work',
          selected: false,
          label: 'Emplois',
          type: 'JOBS'
        },
        {
          icon: 'activityZone',
          selected: false,
          label: 'Entreprises',
          type: 'COMPANIES-ADMINISTRATIONS',
          open: false,
          subCat: [
            {
              icon: 'activityZone',
              selected: false,
              label: 'Grandes entreprises',
              type: 'big-enterprises'
            }
          ]
        }
      ],
      immovable: [
        {
          icon: 'coworking',
          selected: false,
          label: 'Coworking',
          type: 'coworkings'
        },
        {
          icon: 'activityZone',
          selected: false,
          label: "Offre foncière d'entreprise",
          type: 'lands'
        }
      ]
    }
  };
  return widgets[process.env.VUE_APP_PROJECT];
};
